export const stats = [
  { value: '+600', label: 'Unità e Schede Pronte' },
  { value: '+1.800', label: 'Docenti Soddisfatti' },
  { value: '4.200+', label: 'Ore Risparmiate' },
  { value: '99%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+600', label: 'Unità e Attività (1ª Primaria a 3ª Media)' },
  { value: '8', label: 'Volumi Digitali Completi (PDF A4 pronti da stampare)' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a cercare mappe o disegnare linee del tempo da zero',
  'Difficoltà a spiegare concetti complessi (Feudalesimo, Democrazia) in modo semplice',
  'Materiale frammentato e di bassa qualità visiva',
  'Ansia per adattare i test agli alunni con difficoltà',
  'Studenti annoiati che vedono la storia come "solo date"',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per entrare in classe con sicurezza',
  'Infografiche e mappe visuali che rendono comprensibile ogni epoca',
  'Un curriculum completo dalla Preistoria al Novecento, coerente e professionale',
  'Verifiche e mappe BES/DSA già pronte per una didattica davvero inclusiva',
  'Studenti coinvolti che viaggiano nella storia attraverso attività pratiche',
]

export const packItems = [
  {
    emoji: '📚',
    title: '8 Volumi (1ª Primaria – 3ª Media)',
    text: 'Il programma completo di storia, strutturato e pronto all\u2019uso',
  },
  {
    emoji: '🗺️',
    title: 'Mappe Concettuali e Linee del Tempo',
    text: 'Grafiche ad alta risoluzione per orientarsi nei secoli senza sforzo',
  },
  {
    emoji: '📊',
    title: 'Verifiche e Materiali Inclusivi',
    text: 'Strumenti di valutazione per ogni unità, con versioni facilitate per BES/DSA',
  },
  {
    emoji: '🔑',
    title: 'Chiavi di Correzione',
    text: 'Soluzioni complete per correzioni istantanee e zero stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5iVtquezg3dVEJwkCW8XFq/Captura-de-pantalla-2026-09-11-a-las-8.25.11_p._m..webp',
    level: '1ª Primaria · Unità 6',
    title: 'I Dinosauri: gli animali di milioni di anni fa',
    caption:
      'Sei schede illustrate con nome e caratteristica di ogni dinosauro, più la mini linea del tempo che porta i bambini dall\u2019era dei dinosauri a oggi.',
    tag: 'Scheda illustrata',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vhMUjWmupf7gQAf98mwJk6/Captura-de-pantalla-2026-09-11-a-las-8.25.40_p._m..webp',
    level: 'Antiche Civiltà · Attività',
    title: 'Il Nilo: mappa, coltivazioni e inondazione',
    caption:
      'Tre esercizi graduati (facile, medio, difficile) sulla stessa pagina e la nota per l\u2019insegnante con la domanda da fare in classe e la risposta attesa.',
    tag: '3 livelli di difficoltà',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6aeJnuwnB5ovkzTdkk7xth/Captura-de-pantalla-2026-09-11-a-las-8.26.47_p._m..webp',
    level: '2ª Primaria · Linea del Tempo',
    title: 'La linea del tempo dei filosofi greci',
    caption:
      'Da Talete ad Aristotele con date, ritratti e tre riquadri che spiegano metodo socratico, Accademia e Liceo in parole semplici.',
    tag: 'Linea del tempo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iEiaJJNJf2yxNKqncNd1b8/Captura-de-pantalla-2026-09-11-a-las-8.30.42_p._m..webp',
    level: '5ª Primaria · Infografica',
    title: 'L\u2019America dichiara indipendenza',
    caption:
      'Mappa delle 13 colonie affiancata ai sei concetti chiave dell\u2019unità: tasse, «no taxation without representation», guerra e George Washington.',
    tag: 'Infografica',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2YqwyUisSvTCHoVdRTpEQ8/Captura_de_pantalla_2026-09-11_a_las_8.33.07_p.webp',
    level: 'Vol. 6 · Verifica',
    title: 'Assessment Quiz — L\u2019Età Moderna',
    caption:
      '28 domande divise per livello con tempo suggerito, pronte da stampare e con la chiave di correzione già inclusa nel volume.',
    tag: 'Verifica + soluzioni',
  },
]

export const bonuses = [
  {
    title: 'Guida Rapida Storia Pronta — Parti in 10 Minuti',
    was: '€17',
    text: 'Il tuo manuale operativo per trasformare 8 volumi in 36 settimane di lezioni pronte',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/80ad0510-18f9-442d-b0e7-791485bc0781.jpg',
  },
  {
    title: 'Kit Lavagna Storica — Attiva la Classe in 3 Minuti',
    was: '€17',
    text: 'Routine, frasi e domande per trasformare ogni apertura di lezione in una scoperta irresistibile',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3cb1d96c-5a91-4f6e-adcd-d67cb5ba5dde.jpg',
  },
  {
    title: 'Checklist Stampa Perfetta — Archivio Didattico Impeccabile',
    was: '€17',
    text: 'La guida per trasformare i PDF in strumenti fisici pronti all\u2019uso, ordinati e indistruttibili',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/957f7864-89c9-4041-9cdd-dffa26dfce42.jpg',
  },
  {
    title: 'Mappa BES/DSA Facile — Adattamenti Rapidi',
    was: '€17',
    text: 'Come rendere il materiale accessibile a ogni studente, riducendo il carico cognitivo senza perdere qualità',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/27f11887-d3bc-4eb6-88b2-6f5048cfcc03.jpg',
  },
  {
    title: 'Template Comunicazione Genitori',
    was: '€17',
    text: 'Modelli pronti per email e avvisi per coinvolgere le famiglie nel successo degli studenti',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0aba09b6-0564-4b10-9359-977eced64ed3.jpg',
  },
]

export const offerRows = [
  { label: 'STORIA PRONTA™ Pack (8 Volumi Digitali)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€85' },
]

export const testimonials = [
  {
    quote:
      'Ho finalmente recuperato le mie serate. Le mappe visuali sono perfette per i miei alunni DSA.',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      "Dalla prima elementare alle medie, è l'unico investimento necessario per un insegnante di storia.",
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: "Immediatamente via email in formato PDF dopo l'acquisto.",
  },
  {
    q: 'Funziona per le medie?',
    a: 'Sì, il pacchetto include volumi specifici per la scuola secondaria di primo grado.',
  },
  {
    q: 'È adatto per alunni BES/DSA?',
    a: 'Assolutamente, ogni unità include mappe semplificate, verifiche facilitate e font leggibili.',
  },
  {
    q: 'Ci sono costi mensili?',
    a: 'No. Paghi una volta e ricevi aggiornamenti a vita.',
  },
]
